/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Filter by one or more measures.
 * @export
 * @enum {string}
 */
export enum EnMetricMeasure {
    VAS = 'VAS',
    SIMILARITY = 'SIMILARITY',
    EXECUTIONDIFFICULTY = 'EXECUTION_DIFFICULTY',
    MUSCULARDIFFICULTY = 'MUSCULAR_DIFFICULTY',
    BALANCEDIFFICULTY = 'BALANCE_DIFFICULTY',
    ROM = 'ROM',
    BALANCE = 'BALANCE',
    STRENGTH = 'STRENGTH',
    SMOOTHNESS = 'SMOOTHNESS',
    VELOCITY = 'VELOCITY',
    SYMMETRY = 'SYMMETRY',
    POWER = 'POWER'
}

